<template>
  <Chain v-if="$hasPermission('prompts.read')" ref="chain" />
  <p-not-found v-else />
</template>

<script>
import Chain from '@/components/chains/ContentChainView.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    Chain,
    'p-not-found': NotFound
  },
  async beforeRouteLeave(to, from, next) {
    if (await this.$refs.chain?.readyToLeave()) {
      next();
    } else {
      next(false);
    }
  }
};
</script>
